import type { ExperimentRouter } from "replo-publisher/src/trpc/routers/experiment";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: experimentRouter,
  client: experimentClient,
  utils: experimentUtils,
  options: experimentOptions,
} = createTrpcRouterConfig<ExperimentRouter>({
  path: "experiment",
  queryClient: getNamespacedQueryClient("experiment"),
});

export {
  experimentClient,
  experimentRouter,
  experimentUtils,
  experimentOptions,
};
